module.exports = __webpack_public_path__ + "img/mall09.c6205501.png";